import i18n from './../../../shared/i18n';
import BaseModel from "../../../core/components/input-widget/BaseModel";
import i18nHelper from "@/core/services/i18n.service";
import {Formatter} from "@/core/services/formatter.service";
import {store} from "@/plugins/vuex";

export default class ManualInvoiceModel extends BaseModel {
  uuid = null;
  customer_uuid = null;
  is_exported = null;
  is_tax_applied = null;
  is_registered_business = null;
  shipping_amount = null;
  shipping_vat = null;
  shipping_taxable = null;
  preferred_language_code = null;
  complaint_status = null;
  shipping_tracking_code = null;
  tax_rate = null;
  financial_items = [];
  miscellaneous_items = [];
  date = Formatter.getCurrentDate();
  invoice_billing_address = null;
  invoice_shipping_address = null;
  shipping_auto_calculation = store.state.global ? store.state.global.shippingConfigEnabled : false;
  enable_shipping = store.state.global ? store.state.global.shippingConfigEnabled : false;
  is_pickup = null;

  static TRANSLATABLE_FIELDS = [];
  exclude_from_auto_payments = null;

  rules = {
    customer_uuid: 'required',
    preferred_language_code: 'required',
  };

  attributeLabels = {
    customer_uuid: i18n.t('Customer'),
    shipping_address_uuid: i18n.t('Shipping Address'),
    is_exported: i18n.t('Exported'),
    is_tax_applied: i18n.t('Apply VAT'),
    is_registered_business: i18n.t('Exported outside EU'),
    preferred_language_code: i18n.t('Preferred Language'),
    complaint_status: i18n.t('Complaint Status'),
    tax_rate: i18n.t('Tax Rate'),
    date: i18n.t('Date'),
    shipping_auto_calculation: i18n.t('Calculate Shipping Automatically'),
    is_pickup: i18n.t('Being Collected'),
    display_currency_uuid: i18n.t('Display Currency'),
    exclude_from_auto_payments: i18n.t('Exclude from Auto-Payments'),
  };

  attributeHints = {
    preferred_language_code: i18n.t('Invoice template will be created according to the selected language'),
  }

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});

    if (this.extra_info && Object.keys(this.extra_info).length > 0) {
      for (let key in this.extra_info) {
        this[key] = this.extra_info[key]
      }
    }

    if (this.uuid) {
      this.enable_shipping = this.shipping_amount && this.shipping_amount > 0;
    }

    this.preferred_language_code = this.preferred_language_code || i18nHelper.getMasterLanguage().key;
  }
}
